import { PayloadAction } from '@reduxjs/toolkit';
import { ImageHandlingState } from '@reducers/v2/imageHandlingV2/imageHandlingV2.slice';
import { DocumentCategories } from '@v2/components/imageHandling/types/types';

export const setDocumentCategoriesAction = (state: ImageHandlingState, action: PayloadAction<DocumentCategories>) => {
  state.documentCategories = action.payload;
};
